import { inject, provideAppInitializer } from '@angular/core';
import { FieldRegistryService } from './field-registry.service';
import { StatusRegistryService } from './status-registry.service';

export const designSystemInitProvider = provideAppInitializer(() => {
  const fieldRegistry = inject(FieldRegistryService);
  const statusRegistry = inject(StatusRegistryService);
  return Promise.all([fieldRegistry.load(), statusRegistry.load()]).then(() => {});
});
